const initialState = {
  eventId: null,
  eventName: null,
};

function eventReducer(state = initialState, action) {
  switch (action.type) {
    case "SET_EVENT_ID":
      return {
        ...state,
        eventId: action.payload,
      };
    case "SET_EVENT_NAME":
      return {
        ...state,
        eventName: action.payload,
      };
    default:
      return state;
  }
}

export const setEventId = (eventId) => ({
  type: "SET_EVENT_ID",
  payload: eventId,
});

export const setEventName = (eventName) => ({
  type: "SET_EVENT_NAME",
  payload: eventName,
});

export default eventReducer;
